import type { Location } from "history";

export type SmartHistoryLocation = Pick<Location, "pathname" | "search" | "key">;

export const urlToSmartHistoryLocation = (url: string): SmartHistoryLocation => {
	const [pathname, search] = url.split("?");

	return {
		pathname,
		search: search ? `?${search}` : "",
	};
};
